<template>
  <ons-page id="privacy-settings">
    <app-bar :title="$t('privacy_settings.title')" :enable-home="false" />
    <form action="" class="form">
      <ons-list>
        <ons-list-item>
          <div class="center">{{ $t('privacy_settings.profile') }}</div>
          <div class="right por-rm switch-wp">
            <v-ons-select v-model="privacyProfile" :disabled="isOffline">
              <option value="public">{{ $t('privacy_settings.profile_public') }}</option>
              <option value="private">{{ $t('privacy_settings.profile_private') }}</option>
              </option>
            </v-ons-select>
            <icon-progress-circular v-show="privacyProfileLoading" />
          </div>
        </ons-list-item>
      </ons-list>
    </form>
    <v-ons-toast :visible="shouldShowGoOnlineToast" animation="ascend">
      {{ $t("messages.go_online_to_change_settings") }}
      <button @click="goOnline">{{ $t("ui.go_online") }}</button>
    </v-ons-toast>
  </ons-page>
</template>

<script>
import AppBar from '@/components/AppBar.vue';

export default {
  name: 'privacy-settings',
  components: {
    'app-bar': AppBar
  },

  data() {
    return {
      privacyProfileLoading: false,
    };
  },

  computed: {
    privacyProfile: {
      get () {
        return this.currentUser.privacy_profile;
      },
      set (value) {
        let that = this;
        this.privacyProfileLoading = true;
        this.currentUser.update({ privacy_profile: value })
          .catch(() => {
            that.showSomethingWrongToast();
          }).finally(() => {
            this.privacyProfileLoading = false;
          });
      },
    },
  },
};
</script>
